import { useCabinetText } from '../../i18n/CabinetLocale';
import React from 'react';
import { X } from 'lucide-react';
import Dialog from '../common/Dialog';
import { useConfirm } from '../../store/ConfirmContext';

export default function QualificationDialog({ title, children, footer, close, busy, buffer }) {
  const t = useCabinetText();
  const confirm = useConfirm();
  const closeSafely = async () => {
    if (busy) return;
    if (buffer?.count && !await confirm(t("В форме остались несохранённые изменения. Закрыть её? Черновик останется в этой вкладке."), { title: t("Несохранённые изменения"), confirmLabel: t("Закрыть"), cancelLabel: t("Отмена"), danger: false })) return;
    close();
  };
  return <Dialog size="lg" label={title} onClose={closeSafely} closeDisabled={busy} className="qualification-dialog">
    <div className="ap-dialog__header"><h2 data-dialog-heading tabIndex={-1}>{title}</h2><button type="button" className="ap-dialog__close" aria-label={t("Закрыть")} onClick={closeSafely} disabled={busy}><X size={18} /></button></div>
    <div className="ap-dialog__body" onInvalidCapture={event => {
      // Native validation must reveal fields in collapsed settings before focus.
      let parent = event.target.parentElement;
      while (parent && parent !== event.currentTarget) {
        if (parent.tagName === 'DETAILS') parent.open = true;
        parent = parent.parentElement;
      }
    }}>{children}</div>
    <div className="ap-dialog__footer">{footer}</div>
  </Dialog>;
}
